import { CONTACT_SUPPORT_URL } from '@common/constants';
import { DeploymentAnalytics } from '@common/user-analytics/deployment';
import { CheckIcon, HelpCircleIcon, ArrowNarrowLeftIcon } from '@prophecy/ui-v3/Icons';
import { Button } from '@prophecy/ui/Button';
import { Stack } from '@prophecy/ui/Layout';
import { theme } from '@prophecy/ui/theme';

import { useMixPanel } from '../../../context/mixpanel/context';
import { DeploymentStepBaseProp } from '../types';

type DeploymentStepFooterProps = DeploymentStepBaseProp & {
  eventCategory?: string;
};

export function DeploymentStepFooter({ nextStep, prevStep, eventCategory }: DeploymentStepFooterProps) {
  const { track } = useMixPanel();

  return (
    <Stack direction='horizontal' align='space-between'>
      <Button
        onClick={() => {
          if (eventCategory) {
            track(DeploymentAnalytics.events['deployment.previousStep'], {}, eventCategory);
          }
          prevStep();
        }}
        variant='secondaryGray'
        icon={<ArrowNarrowLeftIcon type='default' />}
        aria-label='Previous step'
        data-test-id='deployment-step-footer-previous-step-button'
      />
      <Stack direction='horizontal' gap={theme.spaces.x20}>
        <Button
          elementType='anchor'
          target='_blank'
          href={CONTACT_SUPPORT_URL}
          iconPlacement='left'
          icon={<HelpCircleIcon type='default' />}
          variant='secondaryGray'
          data-test-id='deployment-step-footer-help-button'>
          I need help
        </Button>
        <Button
          onClick={() => {
            if (eventCategory) {
              track(DeploymentAnalytics.events['deployment.nextStep'], {}, eventCategory);
            }
            nextStep();
          }}
          iconPlacement='left'
          icon={<CheckIcon type='default' />}
          data-test-id='deployment-step-footer-next-step-button'>
          I have completed these steps
        </Button>
      </Stack>
    </Stack>
  );
}
